import axios from "axios";
import { MaterialProperties } from "../../types/Views/MappingWizard/MaterialProperties";
import NewSpeckleChild from "../../types/Views/MappingWizard/NewSpeckleChild";
import CarbonClient from "../CarbonClient";
import { ValueWithUnit } from "../types/common";
import { SpeckleMaterial } from "@/types/Views/MappingWizard/SpeckleMaterial";
import { ExcelImportResponse } from "../../types/Views/MappingWizard/ExcelImportResponse";

//GET
export async function getGenerateReport(id: string | string[]) {
  const response = await CarbonClient.post(`/api/BuildingProject/report/${id}`);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export async function getGenerateLcaDocumentationReport(id: string | string[]) {
  const response = await CarbonClient.post(`/api/BuildingProject/excelreport/${id}`);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export async function getGenerateLca2025DocumentationReport(id: string | string[]) {
  const response = await CarbonClient.post(`/api/BuildingProject/${id}/excelreport/standardformat2025`);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export async function getGenerateDgnbDocumentationReport(id: string | string[]) {
  const response = await CarbonClient.post(`/api/BuildingProject/${id}/excelreport/dgnb`);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export async function getGenerateDocumentationReport(id: string | string[]) {
  const response = await CarbonClient.post(`/api/BuildingProject/${id}/excelreport/documentation`);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export async function generateSwedishExcelReport(projectId: string) {
  try {
    await CarbonClient.post(`/api/BuildingProject/${projectId}/report/excel/sweden`);
    return true;
  } catch (_) {
    return false;
  }
}

export async function getGenerateXmlDocumentationReport(buildingProjectId: string) {
  const response = await CarbonClient.post(`/api/BuildingProject/${buildingProjectId}/report/xml`);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export async function getProjectMaterials(projectId: string | string[], byType: boolean, revisionId?: string) {
  // revisionId: pins the materials list to a revision's saved state (as-of read).
  // Absent = live head. Axios drops undefined params, so the wire is unchanged when not previewing.
  const response = await CarbonClient.get(`api/Mapping/buildingproject/${projectId}/materials`, {
    params: { byType, revisionId },
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getSpeckleMaterials(buildingprojectId: string | string[], byType: boolean, models?: string[]) {
  const response = await CarbonClient.get(`api/Mapping/buildingproject/${buildingprojectId}/materials`, {
    params: { byType, model: models },
    paramsSerializer: {
      indexes: true,
    },
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getSuggestedMappings(buildingProjectId: string, branchName: string) {
  const response = await CarbonClient.get(`/api/BuildingProject/${buildingProjectId}/suggest-mappings`, {
    params: { branchName },
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getIndicatorTypes() {
  const response = await CarbonClient.get(`api/Mapping/indicatortypes`);

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
export async function getExcelTemplate() {
  const response = await CarbonClient.get(`api/Mapping/importmaterialsexceltemplate`, {
    responseType: "blob",
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function getCanMapDictionaries() {
  const response = await CarbonClient.get(`api/Mapping/CanMapDictionaries`);

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

//PUT
export async function removeMaterial(buildingprojectId: string | string[], speckleMaterialId: string) {
  const materialIds = [speckleMaterialId];

  const response = await CarbonClient.delete(`api/Mapping/buildingproject/${buildingprojectId}/mapmaterials`, {
    data: {
      materialIds,
    },
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function updateDeclaredUnit(buildingprojectId: string | string[], speckleMaterialId: string, newUnit: object) {
  const response = await CarbonClient.put(
    `api/Mapping/buildingproject/${buildingprojectId}/material/${speckleMaterialId}/updatedeclaredunit`,
    newUnit
  );

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function removeDeclaredUnit(buildingprojectId: string | string[], speckleMaterialId: string, unitToRemove: object) {
  const response = await CarbonClient.put(
    `api/Mapping/buildingproject/${buildingprojectId}/material/${speckleMaterialId}/removedeclaredunit`,
    unitToRemove
  );

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function updateLifeTime(buildingprojectId: string | string[], speckleMaterialId: string, newLifetime: number) {
  const response = await CarbonClient.put(
    `api/Mapping/buildingproject/${buildingprojectId}/material/${speckleMaterialId}/updatelifetime`,
    newLifetime
  );

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function updateIncludeMapping(
  buildingprojectId: string | string[],
  speckleMaterialId: string,
  includeMapping: boolean
) {
  const response = await CarbonClient.put(
    `api/Mapping/buildingproject/${buildingprojectId}/material/${speckleMaterialId}/updateincludemapping`,
    null,
    { params: { includeMapping } }
  );

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export async function updateIsRecycled({
  buildingProjectId,
  speckleMaterialId,
  newIsRecycled,
}: {
  buildingProjectId: string;
  speckleMaterialId: string;
  newIsRecycled: boolean;
}) {
  const response = await CarbonClient.put(
    `api/Mapping/buildingproject/${buildingProjectId}/material/${speckleMaterialId}/updateisrecycled`,
    newIsRecycled
  );

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export type UpdateMaterialPropertiesResponse = { materials: SpeckleMaterial[] } | { status: number; message: string };

export const UpdateMaterialPropertiesRequest = async (
  projectId: string,
  byType: boolean,
  materialProperties: Array<MaterialProperties>
): Promise<UpdateMaterialPropertiesResponse> => {
  const response = await CarbonClient.put(`/api/Mapping/buildingproject/${projectId}/materialsproperties`, materialProperties, {
    params: { byType },
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
};

//POST
/* export async function validateMappings(
  buildingprojectId: string | string[],
  speckleMaterialIds: Array<String>,
  epdMaterialId: string
) {
  const response = await CarbonClient.post(
    `api/Mapping/buildingproject/${buildingprojectId}/validatemappings`,
    { materialIds: speckleMaterialIds, epdMaterialId: epdMaterialId }
  );

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
} */
export async function mapMaterials(buildingprojectId: string | string[], data: object) {
  const response = await CarbonClient.post(`api/Mapping/buildingproject/${buildingprojectId}/mapmaterials`, data);

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
export async function importMaterialsFromExcel(
  buildingProjectId: string,
  branchName: string,
  file: File,
  overwriteExisting: boolean
): Promise<ExcelImportResponse> {
  const formData = new FormData();

  formData.append("files", file);

  try {
    const response = await CarbonClient.post(
      `/api/Mapping/buildingproject/${buildingProjectId}/importmaterialsfromexcel`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        params: { branchName, overwriteExisting },
      }
    );

    return response.data as ExcelImportResponse;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data) {
      const data = error.response.data;
      if ("importRowErrors" in data || "importError" in data) {
        return data as ExcelImportResponse;
      }
    }
    throw error;
  }
}

export async function addMappingMaterial(buildingprojectId: string | string[], data: NewSpeckleChild | NewSpeckleChild[]) {
  const payload = Array.isArray(data) ? data : [data];
  const response = await CarbonClient.post(`api/Mapping/buildingproject/${buildingprojectId}/addmaterial`, payload);
  if (response.status === 200) {
    return response.data as SpeckleMaterial[];
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

//DELETE
export async function deleteSpeckleMaterial(buildingprojectId: string | string[], materialId: string) {
  const response = await CarbonClient.delete(`api/Mapping/buildingproject/${buildingprojectId}/deletematerial/${materialId}`);

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

export type GetSpecialConditionsDimensions = {
  areaOfConstruction?: ValueWithUnit;
  length?: ValueWithUnit;
  project: ValueWithUnit;
};

export type GetSpecialConditionsEmissions = {
  referenceValue: ValueWithUnit;
  result: ValueWithUnit;
  specialConditionIncreasedEmission: ValueWithUnit;
  totalMaterialEmission: ValueWithUnit;
};

export type GetSpecialConditionsResponse = {
  id: string;
  description?: string; // A "custom" description that can be set when saving a mapping, will always be null if none exists
  dimensions: GetSpecialConditionsDimensions; // Depending on the specialConditionTypeId, either "areaOfConstruction" or "length" is used in the formula
  emissions: GetSpecialConditionsEmissions; // this be everything emission related
  enabled: boolean; // Whether a mapping exists already or not
};

export type GetSpecialConditionTypeMappingInput = {
  buildingProjectId: string;
  dimensions: { areaOfConstruction?: number; length?: number };
  model: string;
  specialConditionTypeId?: string;
  typeIdentifier: string;
  /**
   * Pins the read to a revision's saved state (as-of read); absent = working state. This response
   * carries the saved DESCRIPTION and dimensions, so without it a preview showed the working
   * state's description under a frozen revision's name (RTLCA-5259). Resolve it at call time from
   * readPinRevisionIdFor — never from a value captured earlier.
   */
  revisionId?: string;
};

export async function GetSpecialConditionTypeMappingByTypeIdentifier({
  buildingProjectId,
  dimensions,
  model,
  specialConditionTypeId,
  typeIdentifier,
  revisionId,
}: GetSpecialConditionTypeMappingInput & {}): Promise<GetSpecialConditionsResponse> {
  const response = await CarbonClient.get<GetSpecialConditionsResponse>(`/api/Mapping/special-conditions/type`, {
    params: {
      buildingProjectId,
      ...dimensions,
      model,
      specialConditionTypeId,
      typeIdentifier,
      // Axios drops undefined params, so the wire is unchanged when not previewing.
      revisionId,
    },
  });

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }

  throw new Error(`Failed to fetch special condition type mapping: ${response.statusText}`);
}
